export const handleChange = (
  event: any,
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void,
) => {
  const rawValue = event.target.value.replace(/[^\d,]/g, "").replace(",", ".");
  if (onChange) {
    const fakeEvent = {
      ...event,
      target: { ...event.target, value: rawValue },
    };
    onChange(fakeEvent as React.ChangeEvent<HTMLInputElement>);
  }
};
